var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 1.99597,
  width: 20,
  height: 19.96,
  rx: 6,
  fill: "url(#paint0_radial_8201_15448)"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 1.99597,
  width: 20,
  height: 19.96,
  rx: 6,
  fill: "url(#paint1_radial_8201_15448)"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 1.99597,
  width: 20,
  height: 19.96,
  rx: 6,
  fill: "url(#paint2_radial_8201_15448)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0003 8.05527C17.0003 8.64582 16.5206 9.12455 15.9289 9.12455C15.3371 9.12455 14.8574 8.64582 14.8574 8.05527C14.8574 7.46472 15.3371 6.98598 15.9289 6.98598C16.5206 6.98598 17.0003 7.46472 17.0003 8.05527Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.0003 15.5403C13.9727 15.5403 15.5717 13.9445 15.5717 11.976C15.5717 10.0075 13.9727 8.4117 12.0003 8.4117C10.0278 8.4117 8.42885 10.0075 8.42885 11.976C8.42885 13.9445 10.0278 15.5403 12.0003 15.5403ZM12.0003 14.1146C13.1837 14.1146 14.1431 13.1571 14.1431 11.976C14.1431 10.7949 13.1837 9.83741 12.0003 9.83741C10.8168 9.83741 9.85742 10.7949 9.85742 11.976C9.85742 13.1571 10.8168 14.1146 12.0003 14.1146Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.85742 11.6908C4.85742 9.29542 4.85742 8.0977 5.32454 7.18277C5.73542 6.37798 6.39105 5.72366 7.19746 5.31359C8.11423 4.84741 9.31434 4.84741 11.7146 4.84741H12.286C14.6862 4.84741 15.8863 4.84741 16.8031 5.31359C17.6095 5.72366 18.2651 6.37798 18.676 7.18277C19.1431 8.0977 19.1431 9.29542 19.1431 11.6908V12.2611C19.1431 14.6565 19.1431 15.8543 18.676 16.7692C18.2651 17.574 17.6095 18.2283 16.8031 18.6384C15.8863 19.1046 14.6862 19.1046 12.286 19.1046H11.7146C9.31434 19.1046 8.11423 19.1046 7.19746 18.6384C6.39105 18.2283 5.73542 17.574 5.32454 16.7692C4.85742 15.8543 4.85742 14.6565 4.85742 12.2611V11.6908ZM11.7146 6.27313H12.286C13.5097 6.27313 14.3415 6.27424 14.9845 6.32666C15.6108 6.37773 15.9311 6.4703 16.1545 6.58391C16.6921 6.85729 17.1292 7.2935 17.4032 7.83003C17.517 8.05301 17.6097 8.37266 17.6609 8.99772C17.7135 9.63942 17.7146 10.4696 17.7146 11.6908V12.2611C17.7146 13.4824 17.7135 14.3125 17.6609 14.9542C17.6097 15.5793 17.517 15.899 17.4032 16.1219C17.1292 16.6585 16.6921 17.0947 16.1545 17.3681C15.9311 17.4817 15.6108 17.5742 14.9845 17.6253C14.3415 17.6777 13.5097 17.6788 12.286 17.6788H11.7146C10.4909 17.6788 9.65903 17.6777 9.01605 17.6253C8.38974 17.5742 8.06945 17.4817 7.84602 17.3681C7.30841 17.0947 6.87133 16.6585 6.5974 16.1219C6.48356 15.899 6.39081 15.5793 6.33964 14.9542C6.2871 14.3125 6.28599 13.4824 6.28599 12.2611V11.6908C6.28599 10.4696 6.2871 9.63942 6.33964 8.99772C6.39081 8.37266 6.48356 8.05301 6.5974 7.83003C6.87133 7.2935 7.30841 6.85729 7.84602 6.58391C8.06945 6.4703 8.38974 6.37773 9.01605 6.32666C9.65903 6.27424 10.4909 6.27313 11.7146 6.27313Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_8201_15448",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(9.14286 16.966) rotate(-55.3222) scale(18.2036 18.2165)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B13589"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79309,
  stopColor: "#C62F94"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8A3AC8"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_8201_15448",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(8.42857 22.6688) rotate(-65.0925) scale(16.1122 16.133)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E0E8B7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.444662,
  stopColor: "#FB8A2E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71474,
  stopColor: "#E2425C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E2425C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial_8201_15448",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0.928573 2.70883) rotate(-8.11406) scale(27.7781 5.93004)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.156701,
  stopColor: "#406ADC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.467799,
  stopColor: "#6A45BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6A45BE",
  stopOpacity: 0
})));

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.22bbfc01b5a1d2814bae425c52e2c6cc.svg";
export { ForwardRef as ReactComponent };